import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useLanguage } from '../App';
import { t } from '../i18n';
import { motion } from 'framer-motion';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function ForgotPasswordPage() {
  const navigate = useNavigate();
  const { language } = useLanguage();
  const [email, setEmail] = useState('');
  const [code, setCode] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [step, setStep] = useState('email');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [devCode, setDevCode] = useState('');

  const handleRequestCode = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      const res = await fetch(`${BACKEND_URL}/api/auth/forgot-password`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.detail || 'Failed');
      setStep('code');
    } catch (err) { setError(err.message); }
    finally { setLoading(false); }
  };

  const handleReset = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      const res = await fetch(`${BACKEND_URL}/api/auth/reset-password`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, code, new_password: newPassword })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.detail || 'Failed');
      setStep('success');
    } catch (err) { setError(err.message); }
    finally { setLoading(false); }
  };

  return (
    <div className="auth-page">
      <motion.div className="auth-card" initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
        <div className="auth-logo">
          <img src="/pantass-logo.jpg" alt="PANTASS" style={{ width: 40, height: 40, borderRadius: 10 }} />
          <span className="auth-logo-text">PANTASS</span>
        </div>

        {step === 'email' && (
          <>
            <h1 className="auth-title">{t('forgotPassword', language)}</h1>
            <p className="auth-subtitle">{t('forgotPasswordDesc', language)}</p>
            {error && <div className="auth-error">{error}</div>}
            <form onSubmit={handleRequestCode} className="auth-form">
              <div className="auth-field">
                <label>{t('email', language)}</label>
                <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="cikgu@sekolah.my" required />
              </div>
              <button type="submit" className="auth-submit" disabled={loading}>{loading ? '...' : t('sendCode', language)}</button>
            </form>
            <p className="auth-switch"><Link to="/login" className="auth-link">{t('backToLogin', language)}</Link></p>
          </>
        )}

        {step === 'code' && (
          <>
            <h1 className="auth-title">{t('resetPassword', language)}</h1>
            <p className="auth-subtitle">{t('enterCodeDesc', language)}</p>
            {devCode && <div style={{background:'#fef3c7',padding:'10px 14px',borderRadius:'12px',fontSize:'13px',color:'#92400e',fontWeight:700,marginBottom:'12px'}}>Dev code: <strong>{devCode}</strong></div>}
            {error && <div className="auth-error">{error}</div>}
            <form onSubmit={handleReset} className="auth-form">
              <div className="auth-field">
                <label>{t('resetCode', language)}</label>
                <input type="text" value={code} onChange={e => setCode(e.target.value)} placeholder="123456" required maxLength={6} style={{textAlign:'center',fontSize:'24px',letterSpacing:'8px',fontFamily:'Roboto Mono'}} />
              </div>
              <div className="auth-field">
                <label>{t('newPassword', language)}</label>
                <input type="password" value={newPassword} onChange={e => setNewPassword(e.target.value)} placeholder={t('passwordPlaceholder', language)} required minLength={6} />
              </div>
              <button type="submit" className="auth-submit" disabled={loading}>{loading ? '...' : t('resetPasswordBtn', language)}</button>
            </form>
          </>
        )}

        {step === 'success' && (
          <>
            <div style={{fontSize:'56px',marginBottom:'12px'}}>&#9989;</div>
            <h1 className="auth-title">{t('passwordResetSuccess', language)}</h1>
            <p className="auth-subtitle">{t('passwordResetSuccessDesc', language)}</p>
            <button className="auth-submit" onClick={() => navigate('/login')}>{t('loginBtn', language)}</button>
          </>
        )}
      </motion.div>
    </div>
  );
}
